const klaviyoFormEl = document.querySelector('.js-newsletter-klaviyo-form') as HTMLFormElement

if (klaviyoFormEl) {
  const messagesEl = klaviyoFormEl.querySelector('[data-footer-form-messages]')
  const sentMessageEl = klaviyoFormEl.querySelector('[data-footer-form-sent-message]') as HTMLElement

  klaviyoFormEl.addEventListener('submit', async (e) => {
    e.preventDefault()

    messagesEl?.classList.remove('_sent', '_valid')

    const formData = new FormData(klaviyoFormEl)
    const body = new URLSearchParams({
      g: <string>formData.get('g'),
      email: <string>formData.get('email')
    })

    const response = await fetch(klaviyoFormEl.action, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body
    })
    const responseJson = await response.json()

    messagesEl?.classList.add('_sent')
    messagesEl?.classList.remove('valid')

    if (responseJson.success) {
      if (sentMessageEl) {
        sentMessageEl.innerHTML = sentMessageEl.dataset.message || ''
      }
    } else {
      const message = responseJson.errors[0]

      if (sentMessageEl) {
        sentMessageEl.innerHTML = message
      }
    }
  })
}
